import React from "react";
import { FormGroup, Label, Button } from "reactstrap";
import $ from 'jquery';

import FetchCall, { sendsaveOTP, verifyOTP } from '../../API/FetchCall';


const Step3Dance = props => {
  if (props.currentStep !== 3) {
    return null;
  }

  $('#country-codes li a').on('click', function() {
    $('#country-codes button span.value').text($(this).attr('value'));
    $("#countrycode").val($(this).attr('value'));
  });


  function sendOTP(){
      
      $(".sendoptbutton").hide();
      $("#verifiedstatus").removeClass('greentext').removeClass('redtext');
      $("#verifiedstatus").html('please wait....');

      let leaddata = JSON.stringify({
        mobilenumber: $("#countrycode").val()+$("#Mobilenumber").val(),
        email: $("#email").val(),
        subject: "BEWISE"
      })

      var mobilenumber = $("#Mobilenumber").val();

      if(isNaN(mobilenumber)==true){
        $(".sendoptbutton").show();
          $("#verifiedstatus").addClass('redtext');
         $("#verifiedstatus").html('Please check your mobile number is numeric characters');
      }else{

      if(mobilenumber.length>10 || mobilenumber.length<10){
          $(".sendoptbutton").show();
          $("#verifiedstatus").addClass('redtext');
          $("#verifiedstatus").html('Please check your mobile number is 10 characters');
      }
      else{

      sendsaveOTP(leaddata).then((response) => {
          if (response.status==1) {
              $("#verifiedstatus").addClass('greentext');
              $("#verifiedstatus").html('OTP is sent to your mobile number and your email id and mobile number.');
              $(".verificationopen").removeClass('hidden');
          }
          else{
              $(".sendoptbutton").show();
              $("#verifiedstatus").addClass('redtext');
              $("#verifiedstatus").html('Issue in sending OTP.');
              $(".verificationopen").addClass('hidden');
          }
      }); 

      }}

  }

  
  function verifyOTPsent(){
      
      $("#Otp").removeClass('invalid').removeClass('valid');

      $("#verifiedstatus").removeClass('greentext').removeClass('redtext');
      $("#verifiedstatus").html('please wait....');

      let leaddata = JSON.stringify({
        mobilenumber: $("#countrycode").val()+$("#Mobilenumber").val(),
        otp: $("#Otp").val(),
      })

      verifyOTP(leaddata).then((response) => {
          if (response.status==1) {
              $("#Otp").addClass('valid');
              $("#verifiedstatus").addClass('greentext').html('Successfully verified.');
          }
          else if (response.status==2) {
              $("#Otp").addClass('invalid');
              $(".sendoptbutton").show().html('Resend OTP');
              $("#verifiedstatus").addClass('redtext').html('OTP is invalid.');
          }
          else{
              $("#verifiedstatus").html('Issue verifying OTP.');
          }
      }); 

  }

  return (
    <>
      <p>Please update information required to help you discover the best fit/s </p>
      <div class="finalstepform">
      <div class="form-row">
          <div class="form-group col-md-6">
            <Label for="Firstname">Firstname</Label>
            <input
              type="text"
              class="form-control form-control-sm"
              name="Firstname"
              id="Firstname"
              placeholder="Enter your Firstname"
              value={props.Firstname} 
              onChange={props.handleChange} 
            /
            >
        </div>
          <div class="form-group col-md-6">
            <Label for="Lastname">Lastname</Label>
            <input
              type="text"
              class="form-control form-control-sm"
              name="Lastname"
              id="Lastname"
              placeholder="Enter your Lastname"
              value={props.Lastname} 
              onChange={props.handleChange} 
            />
          </div>
        </div>
        <div class="form-row">
        <div class="col-auto">
        
        <Label for="Email">Email Address</Label>
            <input
              type="email"
              class="form-control form-control-sm"
              name="email"
              id="email"
              placeholder="Enter your email address"
              value={props.email} 
              onChange={props.handleChange}
            />
           
        </div>
        <div class="col-auto">

           <Label for="Mobile">Mobile Number</Label>
          <div class="dropdown" id="country-codes">
            <input type="hidden" name="countrycode" id="countrycode" value="91" />
            <button class="btn btn-primary btn-sm dropdown-toggle ccode" type="button" data-toggle="dropdown">
              <span class="value">+91</span>
              <span class="caret"></span>
            </button>
            <input
            type="text"
            name="Mobilenumber"
            class="form-control form-control-sm"
            id="Mobilenumber"
            placeholder="Enter your Mobile Number"
            value={props.Mobilenumber} 
            onChange={props.handleChange} 
          />
            <ul class="dropdown-menu">
              <li><a value="+91">India (+91)</a></li>
            </ul>
          </div>

           
          
        </div>
        
        <div class="col-auto">
        <div class="btn btn-primary btn-sm mb-2 sendoptbutton" onClick={sendOTP}>send OTP</div>
        </div>
        
        </div>
        <div class="form-row mt-2 verificationopen hidden">
          <div class="form-group mb-2">
            <Label for="Mobile">OTP</Label>
          </div>
        <div class="form-group mx-sm-3 mb-2">    
        <input
          type="text"
          class="form-control form-control-sm"
          name="otp"
          id="Otp"
          placeholder="Enter your OTP received"
          value={props.otp} 
          onChange={props.handleChange} 
        />
        </div>
          <div class="btn btn-primary btn-sm mb-2" onClick={props.verifyOTPsent}>verify OTP</div>
        </div>
        <div class="text-center">
          <span class="verification" id="verifiedstatus"></span>
        </div>
        <br/>
        <div class="form-check">
      <input class="form-check-input" type="radio" name="accepttakingcalls" value="call" checked onChange={props.handleChange}/>
      <label class="form-check-label">I will be fine to receive calls (maximum 5) from best suited coach/teacher/mentor/tutor</label>
      </div>
      <div class="form-check">
      <input class="form-check-input" type="radio" name="accepttakingcalls" value="listing" onChange={props.handleChange}/>
      <label class="form-check-label">I will be fine to call the best suited coach/teacher/mentor/tutor(s) myself</label>
      <span class="smallnote">For your convenience, a mail with Top 5 from this short list will also be sent to your mail box. </span>
      </div>
        
      </div>
    </>
  );
};

export default Step3Dance;
